<template lang="pug">
  .schedule-calendar
    .schedule-calendar__header
      .schedule-calendar__controller
        button.controller__btn(@click="setPrevMonth")
          v-icon(name="chevron-right" :size="12")
        p.controller__date
          span {{ date.toLocaleString("ru-RU", { month: "long" }) }}, {{`${firstDayOfTheWeek.format("DD")} - ${lastDayOfTheWeek.format("DD")}`}} &nbsp;
          span | Пн - Вс
        button.controller__btn(@click="setNextMonth")
          v-icon.v-icon--rotate(name="chevron-right" :size="12")

      .schedule-calendar__filters
        el-select(
          :value="currentTeacher"
          placeholder="Преподаватель"
          filterable
          :load="isLoad"
          clearable
          @change="handleChangeTeacher"
        )
          el-option(
            v-for="teacher in teachers"
            :key="teacher.value"
            :label="teacher.name"
            :value="teacher.id"
          )

        el-select(
          :value="currentGroup"
          placeholder="Номер группы"
          filterable
          remote
          :load="isLoad"
          :remote-method="event => $emit('search', { type: 'group', value: event })"
          @blur="$emit('search', { type: 'group', value: '' })"
          @change="handleChangeGroup"
        )
          el-option(
            v-for="group in groups"
            :key="group.value"
            :label="group.name"
            :value="group.id"
          )

      el-button.schedule-calendar__sync-modal(
        @click="showSincModal"
      ) Синхронизировать календарь

    .schedule-calendar__body(ref="calendar-body")
      .body__column(
        :class="{ '--is-now': setSelectorColumnNow(day), '--is-events': filteringByStatus(day).length, '--is-selected': setSelectorColumn(day) }"
        v-for="(day, idx) of days"
        :key="idx"
        @click="selectDay(day)"
      )
        .column__header
          .header__day {{ +day.format("DD") }}
          .header__weak-name {{ weekNames[idx] }}

        .column__body(v-if="!mobileMode")
          .event-tab(
            v-for="(event, idx) of filteringByStatus(day)"
            :key="idx"
            @click.stop="handleTabCkick(event)"
          )
            span.event-tab__date {{ event.time_begin }} - {{ event.time_end }}
            b.event-tab__title {{ event.discipline.toUpperCase() }}
            span.event-tab__type(v-if="event.type_workload") {{ event.type_workload }}
            .event-tab__groups(v-if="event.groups && event.groups.length")
              span.event-tab__group(v-for="item in sortedGroups(event.groups)" :key="item.group") {{ item.group }}

    .schedule-calendar__tabs
      event-tab.schedule-calendar__tab(
        v-for="(tab, idx) in eventsOnSelectedDay"
        :key="`tab-${idx}`"
        :component-data="tab"
      )
</template>

<script>
import { mapMutations } from 'vuex';
import tabColors from './tabColors';
import eventTab from '@/components/modalContents/eventTab';

export default {
  components: { eventTab },

  props: {
    events: Array,
    selectedDay: [Object, null],
    isLoad: {
      type: Boolean,
      default: false
    },
    teachers: {
      type: Array,
      default: () => ([])
    },
    groups: {
      type: Array,
      default: () => ([])
    }
  },

  data() {
    return {
      currentTeacher: null,
      currentGroup: null,
      checkboxes: {
        change: false,
        all: true,
        checkList: {
          educational: false,
          session: false,
          college: false,
          yourown: false,
        },
        statusOptions: ['учебные', 'сессия', 'колледж', 'свои'],
      },

      date: new Date(),
      weekNames: ['пон', 'вт', 'ср', 'чт', 'пят', 'суб', 'вс'],
    };
  },

  watch: {
    days() {
      this.handleChange();
    },
  },

  computed: {
    eventsOnSelectedDay() {
      return this.selectedDay ? this.events.filter((event) => event.date === this.selectedDay.format('YYYY-MM-DD')) : [];
    },
    dateStart() {
      return this.$moment(this.date).locale('ru').startOf('week').format('YYYY-MM-DD')
    },
    dateEnd() {
      return this.$moment(this.date).locale('ru').endOf('week').format('YYYY-MM-DD')
    },
    mobileMode() {
      return this.$store.state.mobileMode;
    },
    days() {
      return [0, 1, 2, 3, 4, 5, 6].map((i) => this.$moment(this.firstDayOfTheWeek).add(i, 'days').locale('ru'));
    },
    colorsForTab() {
      return tabColors;
    },
    currentDate() {
      return this.$moment();
    },
    firstDayOfTheWeek() {
      return this.$moment(this.date).locale('ru').startOf('week');
    },
    lastDayOfTheWeek() {
      return this.$moment(this.date).locale('ru').endOf('week');
    },
  },

  methods: {
    ...mapMutations({
      setModalData: "setModalData",
    }),

    handleChangeTeacher(value) {
      this.currentTeacher = value;
      this.currentGroup = null
      this.handleChange();
      this.$emit('search', { type: 'teacher', value: '' });
    },

    handleChangeGroup(value) {
      this.currentGroup = value;
      this.currentTeacher = null
      this.handleChange();
      this.$emit('search', { type: 'group', value: '' });
    },

    handleChange() {
      this.$emit('change', {
        dateStart: this.dateStart,
        dateEnd: this.dateEnd,
        teacherId: this.currentTeacher,
        groupId:  this.currentGroup
      });
    },

    setSelectorColumnNow(day) {
      return day.format('YYYY-MM-DD') === this.currentDate.format('YYYY-MM-DD');
    },

    setSelectorColumn(day) {
      return (
        this.selectedDay !== null
        && this.selectedDay.format('YYYY-MM-DD') === day.format('YYYY-MM-DD')
      );
    },

    setPrevMonth() {
      const nextDate = this.date.setDate(this.date.getDate() - 7);
      this.date = new Date(nextDate);
    },

    setNextMonth() {
      const nextDate = this.date.setDate(this.date.getDate() + 7);
      this.date = new Date(nextDate);
    },

    filterinByDay(day) {
      if (!this.events) return [];
      return this.events.filter((event) => event.date === day.format('YYYY-MM-DD'));
    },

    filteringByStatus(day) {
      const filtredData = this.filterinByDay(day);
      if (this.checkboxes.all) return filtredData;
      const result = {};
      const target = this.checkboxes.checkList;
      for (const key in target) {
        if (target[key]) result[key] = target[key];
      }
      return filtredData.filter((el) => Boolean(result[el.status]));
    },

    handlerCheckboxChange() {
      const target = this.checkboxes.checkList;
      let moreThanZero = false;
      const values = [];
      for (const key in target) {
        if (target[key]) {
          moreThanZero = true;
        }
        values.push(target[key]);
      }
      const allListCheck = values.every((el) => el === true);
      if (moreThanZero) this.checkboxes.all = false;
      if (allListCheck) {
        this.throwAll();
        this.checkboxes.all = true;
      }
    },

    throwAll() {
      const target = this.checkboxes.checkList;
      for (const key in target) {
        target[key] = false;
      }
    },

    selectDay(day) {
      this.$emit('selectDay', day);
    },

    handleTabCkick(day) {
      this.setModalData({ name: "eventTab", data: day, noCover: true });
    },

    showSincModal() {
      this.setModalData({ name: "syncCalendarModal" });
    },

    sortedGroups(groups) {
      if (!groups) return [];
      return [...groups].sort((a, b) => a.group.localeCompare(b.group));
    },
  },
};
</script>

<style lang="scss">
.schedule-calendar {
  width: 100%;
  height: 100%;
  display: grid;
  row-gap: 16px;
  grid-template-rows: auto 1fr;

  @include breakPoints(md) {
    grid-template-rows: auto auto 1fr;
  }

  &__tabs {
    display: none;
    flex-direction: column;
    align-items: center;

    @include breakPoints(md) {
      display: flex;
    }
  }

  &__tab:not(:last-child) {
    margin-bottom: 16px;
  }

  &__sync-modal {
    @include breakPoints(lg) {
      width: 100%;
    }
  }

  .schedule-calendar__filters {
    display: flex;
    gap: 16px;
    width: 100%;

    @include breakPoints(lg) {

      .el-select {
        width: 100%;
      }
    }

    @include breakPoints(sm) {
      flex-wrap: wrap;
    }
  }

  .schedule-calendar__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;

    @include breakPoints(lg) {
      flex-wrap: wrap;
    }
  }

  .schedule-calendar__header-btn {
    display: flex;
    padding: 5px 10px;

    @include breakPoints(lg) {
      width: 100%;
    }

    .v-icon {
      width: 15px;
      margin-right: 10px;
      fill: $basic-white;
    }
  }

  .home__calendar-btn {
    display: flex;
    border-radius: 10px 10px 0 0;

    .v-icon {
      width: 15px;
      margin-right: 10px;
      fill: $basic-white;
    }
  }

  .schedule-calendar__controller {
    justify-items: center;
    align-items: center;
    display: grid;
    grid-template-columns: auto 1fr auto;
    max-width: 276px;
    padding: 10px;
    flex-shrink: 0;
    border: 1px solid #DCDFE6;
    border-radius: 4px;

    @include breakPoints(lg) {
      width: 100%;
      max-width: unset;
    }
  }

  .controller {
    &__date {
      margin: 0;
      color: $regular-text-clr;
      font-size: 14px;

      b {
        color: inherit;
      }
      span {
        color: inherit;
      }
    }

    &__btn {
      color: $regular-text-clr;
    }
  }

  .v-icon--chevron {
    width: 7px;
    fill: $brand-clr-1;
  }

  .v-icon--rotate {
    transform: rotate(180deg);
  }

  .schedule-calendar__weekdays {
    display: grid;
    grid-template-columns: repeat(7, 1fr);
  }

  .schedule-calendar__body {
    height: 100%;
    display: grid;
    grid-template-columns: repeat(7, 1fr);
  }

  .body {
    &__column {
      transition-duration: 0.3s;
      transition-property: background-color;
      border-radius: 10px;
      display: grid;
      grid-template-rows: 70px 1fr;
      cursor: pointer;
      -webkit-tap-highlight-color: rgba(0, 0, 0, 0);

      &.--is-selected {
        background-color: $extra-light-border;
      }

      &.--is-now {
        background-color: #e7eef9;

        &:hover {
          background-color: darken($color: #e7eef9, $amount: 5);
        }
      }

      &:hover {
        background-color: $extra-light-border;
      }
    }
  }


  .body__column:nth-child(7) {
    .column__body {
      border-right: none;
    }
  }

  .column__header {
    grid-template-areas:
      "number"
      "day";
    align-self: center;
    display: grid;
    align-items: center;
    justify-items: center;
    height: max-content;
  }

  .header__day {
    grid-area: number;
    font-size: 18px;
    font-weight: 600;
    color: $basic-black;
  }

  .header__weak-name {
    grid-area: day;
    font-size: 12px;
    color: $basic-black;
  }

  .column__body {
    align-items: flex-start;
    padding: 0 3px;
    border-left: 1px solid transparent;
    border-right: 1px solid $lighter-border-clr;
    row-gap: 8px;
    display: flex;
    flex-direction: column;
  }

  .event-tab {
    row-gap: 5px;
    width: 100%;
    display: grid;
    grid-template-rows: max-content max-content;
    padding: 8px 4px;
    cursor: pointer;
    border-radius: 10px;
    background-color: $brand-clr-1;
    transition-property: transform;
    transition-duration: 0.3s;
    color: white;
    height: max-content;

    &:hover {
      transform: scale(1.1);
    }
  }

  .event-tab__title,
  .event-tab__date {
    color: inherit;
    font-size: 10px;
  }

  .event-tab__type {
    color: rgba(255, 255, 255, 0.7);
    font-size: 10px;
  }

  .event-tab__groups {
    display: flex;
    flex-direction: column;
    gap: 2px;
  }

  .event-tab__group {
    color: inherit;
    font-size: 10px;
  }

  .el-checkbox-group {
    display: grid;
    column-gap: 15px;
    grid-template-columns: repeat(5, 1fr);
    justify-items: center;
    .el-checkbox {
      margin-right: 0;
    }
  }

  .el-checkbox {
    .el-checkbox__label {
      color: $basic-black;
    }
  }

  .el-checkbox__inner {
    width: 16px;
    height: 16px;
    border-width: 2px;
    border-radius: 50%;
  }

  .el-checkbox--is-all {
    .el-checkbox__input .el-checkbox__inner {
      border-color: $basic-black;
    }
    .is-checked {
      .el-checkbox__inner {
        background-color: $basic-black;
      }
    }
    .is-checked .el-checkbox__inner,
    .el-checkbox__input.is-indeterminate .el-checkbox__inner {
      background-color: $basic-black;
    }
  }

  .el-checkbox--educational {
    .el-checkbox__inner {
      border-color: #379e8d;
    }
    .is-checked {
      .el-checkbox__inner {
        border-color: #379e8d;
        background: #379e8d;
      }
    }
  }

  .el-checkbox--session {
    .el-checkbox__inner {
      border-color: #4b5aca;
    }
    .is-checked {
      .el-checkbox__inner {
        border-color: #4b5aca;
        background: #4b5aca;
      }
    }
  }

  .el-checkbox--college {
    .el-checkbox__inner {
      border-color: #ffe946;
    }
    .is-checked {
      .el-checkbox__inner {
        border-color: #ffe946;
        background: #ffe946;
      }
    }
  }

  .el-checkbox--yourown {
    .el-checkbox__inner {
      border-color: #b039c5;
    }
    .is-checked {
      .el-checkbox__inner {
        border-color: #b039c5;
        background: #b039c5;
      }
    }
  }
}

@include breakPoints(md) {
  .schedule-calendar {
    height: auto;

    .schedule-calendar__controller {
      justify-self: center;
      max-width: 100%;
      width: 100%;
    }

    .schedule-calendar__body {
      column-gap: 10px;
    }

    .column__header {
      border-radius: 8px;
      height: 100%;
      row-gap: 10px;
      grid-template-areas:
        "day"
        "number";
    }

    .header__weak-name {
      align-self: flex-end;
    }

    .header__day {
      font-size: 14px;
      align-self: flex-start;
    }

    .body__column {
      padding: 2px;
      &:hover {
        background-color: transparent;
      }
    }

    .body__column.--is-events {
      border: 1px solid $brand-clr-1;
    }

    .body__column.--is-now {
      background-color: transparent !important;

      .column__header {
        background-color: #e7eef9;
      }
    }

    .body__column.--is-selected {
      background-color: transparent !important;
      .column__header {
        background-color: $brand-clr-1 !important;
      }
      .header__weak-name,
      .header__day {
        color: $basic-white;
      }
    }
  }
}
</style>
